import { Component, inject } from '@angular/core';
import { InventoryParametersService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  InventoryParametersCreateDto,
  InventoryParametersDto,
  InventoryParametersExcelDownloadDto,
  InventoryParametersUpdateDto,
} from '../proxy/planning/dtos/inventory-parameters';
import { INVENTORYPARAMETERS_CONFIG, INVENTORYPARAMETERS_FIELDS } from './inventory-parameters.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-inventory-parameters',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, InventoryParametersService, ConfirmationService],
  templateUrl: './inventory-parameters.html',
  styleUrl: './inventory-parameters.scss',
})
export class InventoryParameters extends BaseCrudComponent<
  InventoryParametersDto,
  InventoryParametersCreateDto,
  InventoryParametersUpdateDto,
  InventoryParametersExcelDownloadDto
> {
  service = inject(InventoryParametersService);
  config = INVENTORYPARAMETERS_CONFIG;
  fields = INVENTORYPARAMETERS_FIELDS;

  protected prepareUpdateDto(data: any, selected: InventoryParametersDto): InventoryParametersUpdateDto {
    return {
      name: data.name,
      value: data.value,
      description: data.description,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'InventoryParameters';
  }
}
